import {
  OnlyModulePermissionsIllustration,
  PowerPlugIllustration,
  WithoutBondOptionIllustration,
  WithoutCameraIllustration,
  WithoutPermissionIllustration,
} from 'components'
import EmptyDrawer from 'components/illustrations/EmptyDrawer'

export const getPossibleFeedbacks = (illustrationSize: string) => {
  return {
    withoutCamera: {
      title: 'Você não tem permissão ou câmera no seu dispositivo',
      description: 'Não foi encontrado um dispositivo de video no seu aparelho.',
      Illustration: <WithoutCameraIllustration size={illustrationSize} />,
    },
    withoutBondOption: {
      title: 'A solicitação de vínculo está desativada',
      description: 'A instituição desabilitou as solicitações de vínculos temporariamente.',
      Illustration: <WithoutBondOptionIllustration size={illustrationSize} />,
    },
    notLoggedIn: {
      title: 'Você não está conectado',
      description:
        'Para acessar esta página, é preciso ter um conta e está conectado. Clique abaixo para ser redirecionado para o nosso módulo Login Unificado para se conectar ou para criar uma nova conta.',
      Illustration: <PowerPlugIllustration size={illustrationSize} />,
    },
    withoutMetadatas: {
      title: 'Sem informações complementares',
      description: '',
      Illustration: <EmptyDrawer size={illustrationSize} />,
    },
    withoutCustomForm: {
      title: 'Sem formulário',
      description: 'Nenhum formulário ou questões foram criadas.',
      Illustration: <EmptyDrawer size={illustrationSize} />,
    },
    onlyModulePermissions: {
      title: 'Você tem permissão para o módulo, mas...',
      description:
        ' Você só tem permissão para acessar o módulo e nada mais, ou seja, as suas permissões nas páginas do módulo ainda não foram configuradas pelo administrador.',
      Illustration: <OnlyModulePermissionsIllustration size={illustrationSize} />,
    },
    withoutPermission: {
      title: 'Você não tem a permissão necessária',
      description:
        'A página ou funcionalidade que você quer acessar está protegida por uma permissão que você não possui.',
      Illustration: <WithoutPermissionIllustration size={illustrationSize} />,
    },
    withoutPermissionInTheModule: {
      title: 'Você não tem a permissão necessária',
      description: 'Infelizmente, o módulo que você quer acessar está protegida por uma permissão que você não possui.',
      Illustration: <WithoutPermissionIllustration size={illustrationSize} />,
    },
  }
}
